import axios from "axios";

import HttpService from "@krea/customer-features/services/httpService";
import { settings } from "@krea/customer-features/settings";
import { APPLICATION_NAME } from "@krea/customer-features/utils";

const unAuthenticatedAxiosClient =
  HttpService.createInstanceWithoutInterceptors();

export const hasOngoingApplication = async (
  countryCode,
  email,
  organisationNumber,
) => {
  const response = await unAuthenticatedAxiosClient.post("/api/graphql", {
    query: `
      query HasOngoingApplication($input: HasOngoingApplicationInput!) {
        hasOngoingApplication(input: $input) {
          hasHit
        }
      }
  `,
    variables: {
      input: {
        countryCode,
        email,
        organisationNumber,
      },
    },
  });

  return response.data.data?.hasOngoingApplication?.hasHit;
};

export const submitApplicationAndDeleteDuplicates = async (
  loanApplicationID,
) => {
  const isCustomerWeb = settings.appName === APPLICATION_NAME.CUSTOMER_WEB;
  const URL = isCustomerWeb
    ? "/api/v1/current-loan-application/submit-and-delete-previous-applications"
    : `partner/api/v1/loan-applications/${loanApplicationID}/submit-and-delete-previous-applications`;

  return axios.post(URL);
};

export const submitApplication = async (loanApplicationID) => {
  const isCustomerWeb = settings.appName === APPLICATION_NAME.CUSTOMER_WEB;
  const URL = isCustomerWeb
    ? "/api/v1/current-loan-application/submit"
    : `partner/api/v1/loan-applications/${loanApplicationID}/submit`;

  return axios.post(URL);
};

export const changeCustomerPreferredRate = async (
  loanApplicationID,
  customer_preferred_rate,
) => {
  const isCustomerWeb = settings.appName === APPLICATION_NAME.CUSTOMER_WEB;
  const URL = isCustomerWeb
    ? "/api/v1/current-loan-application/change-customer-preferred-rate"
    : `partner/api/v1/loan-applications/${loanApplicationID}/change-customer-desired-rate`;

  return axios.post(URL, { customer_preferred_rate });
};

export const fetchSelectedLenderResponseData = async () => {
  return client.request(`{
    me {
      currentLoanApplication {
        selectedLenderResponse {
          id,
          signingUrl,
          eligibleForPaymentAt,
          invoicePurchaseBid {
            totalPaidOut,
            purchasedInvoiceAmount,
            commissionPercent,
            comparableMonthlyInterestRate,
            handlingFeePerInvoice,
            monthlyFee,
            purchasedAmountPercent,
            totalMonthlyCost,
            purchaseLimit,
            limitFeePerYearPercent,
            setupFee,
            withRegress,
            regressNumDaysAfterDueDate,
            paidOutPerInvoice,
            paidOutPerInvoicePercent
          },
          paidOutAt,
          lenderApplication {
            id,
            createdAt,
            updatedAt,
            lenderCompany {
              id,
              name,
              description,
              registeredAtFinansinspektionenAt,
              signingUrlTemplate,
              customerContactPhoneNumber,
              customerContactEmail,
              image {
                lowResolutionUrl
              }
            }
          },
          bid {
            monthlyCostWithoutSetupFee,
            amortizationMethodDisplayName,
            amortizationMethodDescription,
            totalLoanCost,
            monthlyCost,
            setupFee,
            postalFee,
            directDebitFee,
            paybackTimeMonths,
            amortizationMethod,
            lenderMonthlyInterest,
            earlyRepaymentFee,
            amount
          },
          realEstateBid {
            id,
            monthlyCostWithoutSetupFee,
            amortizationMethodDisplayName,
            amortizationMethodDescription,
            totalLoanCost,
            monthlyCost,
            setupFee,
            postalFee,
            directDebitFee,
            paybackTimeMonths,
            amortizationMethod,
            lenderMonthlyInterest,
            earlyRepaymentFee,
            amount,
            loanToValueRatio
          },
          leasingBid {
            id,
            amount,
            paybackTimeMonths,
            monthlyPayment,
            totalCost,
            downPayment,
            terminalValue,
            setupFee,
            contractType,
            postalFee,
            insuranceMonthlyCost
          },
          revolvingCreditBid {
            id,
            earlyRepaymentFee,
            directDebitFee,
            amount,
            monthlyAmortisation,
            lenderMonthlyInterest,
            withdrawalFee,
            setupFee,
            limitFeePerYear,
            postalFee,
            monthlyPayment,
            monthlyCost
          },
          fieldRequests {
            id,
            type,
            field,
            displayName,
            displayText,
            required,
            isSubmitted,
            subtitle,
            isCollectedByLender,
            submittedData,
            lenderComment
          },
          processSteps {
            text
          }
        }
      }
    }
  }`);
};
